import React, { useState } from 'react';

type SidebarLinkGroupProps = {
  children: (handleClick: () => void, open: boolean) => JSX.Element | JSX.Element[];
};

export default function SidebarLinkGroup({ children }: SidebarLinkGroupProps) {
  const [open, setOpen] = useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return <li className={`rounded-sm mb-0.5 last:mb-0`}>{children(handleClick, open)}</li>;
}
